import { createStore } from 'vuex';
import { app } from './app';
import { attributes } from './attributes';
import { flowDesigner } from './bot-designer';
import { holidays } from './holidays';
import { reports } from './reports';
import { channelIdentities } from './channel-identities';
import { intents } from './intents';
import { answers } from './answers';

export const store = createStore({
  modules: {
    app,
    attributes,
    flowDesigner,
    holidays,
    reports,
    channelIdentities,
    intents,
    answers,
  },
});
